
import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import Navbar from '@/components/Navbar';
import Footer from '@/components/Footer';

const Unauthorized = () => {
  return (
    <div className="flex flex-col min-h-screen">
      <Navbar />
      
      <main className="flex-grow flex items-center justify-center py-12 px-4">
        <div className="text-center max-w-md">
          <h1 className="text-4xl font-bold text-vegana-primary mb-4">Acceso Denegado</h1>
          <p className="text-lg text-gray-600 mb-8">
            No tienes permiso para acceder a esta página. Por favor, inicia sesión con una cuenta autorizada o actualiza tu suscripción para acceder a todas las funcionalidades.
          </p>
          <Link to="/">
            <Button className="bg-vegana-primary hover:bg-vegana-primary/90">
              Volver al Inicio
            </Button>
          </Link>
        </div>
      </main>
      
      <Footer />
    </div>
  );
};

export default Unauthorized;
